/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2024 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { useState, useEffect } from 'react'

const useLicensesGroup = ({
  licenses = [],
  getLicenses,
  groupId,
  allLicensesChecked = false
}) => {
  const [checkedItems, setCheckedItems] = useState(
    new Array(licenses.length).fill(false)
  )
  const setCheckedValues = (id, checked, price) => ({ id, checked, price })
  const onSelectAll = (event) => {
    const isChecked = event.target.checked
    const licensesValues = licenses.map(license => {
      return setCheckedValues(license.id, isChecked, license.price)
    })

    getLicenses && getLicenses(groupId, licensesValues)
    setCheckedItems(new Array(licenses.length).fill(isChecked))
  }
  const onCheckbox = (index) => {
    const newCheckedItems = [...checkedItems]
    newCheckedItems[index] = !newCheckedItems[index]

    setCheckedItems(newCheckedItems)

    const licensesValues = licenses.map((license, index) => {
      return setCheckedValues(
        license.id,
        newCheckedItems[index],
        license.price
      )
    })
    getLicenses && getLicenses(groupId, licensesValues)
  }
  const allChecked = checkedItems.every(Boolean)

  useEffect(() => {
    setCheckedItems(new Array(licenses.length).fill(allLicensesChecked.checked))
  }, [allLicensesChecked])

  return ({
    allChecked,
    checkedItems,
    onCheckbox,
    onSelectAll
  })
}

export default useLicensesGroup
